import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Dominio} from 'src/app/model/dominio-operacao.model';
import {OperacaoCreditoLivre} from 'src/app/model/operacao-credito-livre.model';
import {OperacaoGarantida} from 'src/app/model/operacao-garantida.model';
import {TipoPagamentoEcgTerceiroService} from '../../../tipo-pagamento-ecg-terceiro.service';
import {TipoPagamentoEcgTerceiro} from 'src/app/model/tipo-pagamento-ecg-terceiro';

@Component({
    selector: 'aba-pagamento-por-terceiros',
    templateUrl: 'aba-pagamento-por-terceiros.component.html',
  standalone: false
})
export class AbaPagamentoPorTerceirosComponent implements OnInit, OnChanges {
    @Input()
    public operacao: OperacaoCreditoLivre;
    @Input()
    public model: OperacaoGarantida;
    @Input()
    public modoEdicao: Boolean;
    @Input()
    public modoAditivo: Boolean;
    @Input()
    public emInclusao: Boolean;
    @Input()
    public dadosDominio: Dominio;


    public identificadorTipoPagamentoEcgTerceiro: number;
    public tiposPagamento: TipoPagamentoEcgTerceiro[];
    public ideTipoPagamento: string = "";
    public podeAdicionar = false;
    private CODIGO_FGE = 1;

    constructor(protected tipoPagamentoService: TipoPagamentoEcgTerceiroService,) {}

    ngOnInit() {
        this.tipoPagamentoService.listarTodos().subscribe(result => this.tiposPagamento = result);

        if (this.operacao.identificadorTipoPagamentoEcgTerceiro) {
            this.podeAdicionar = true;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.identificadorTipoPagamentoEcgTerceiro = this.operacao.identificadorTipoPagamentoEcgTerceiro;
    }

    adicionarGarantia() {
        this.podeAdicionar = true;
    }

    removerTipo() {
        this.podeAdicionar = false;
    }

    atribuirTipo(idePagamento: number) {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.identificadorTipoPagamentoEcgTerceiro = idePagamento;
        this.identificadorTipoPagamentoEcgTerceiro = idePagamento
    }

    get deveAdicionarCodigo() {
        return this.identificadorTipoPagamentoEcgTerceiro == this.CODIGO_FGE;
    }
}
